import { c as _c } from "react/compiler-runtime";
import ModalEventViewContent from "@/app/(main)/(club)/mes-clubs/[id]/components/modal-event-view-content";
import { ModalEventViewHeader } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal-event-view-header";
import { EventEnum } from "@/TS/Enums/global_enums";
import { Club } from "@/TS/Interfaces/global_interfaces";
interface ModalEventViewProps {
  startDate?: string;
  type?: EventEnum;
  clubSlug?: string;
  isPublic?: boolean;
  publicClub?: Club;
}
export const ModalEventView: React.FC<ModalEventViewProps> = t0 => {
  const $ = _c(11);
  const {
    startDate,
    type,
    clubSlug,
    isPublic: t1,
    publicClub
  } = t0;
  const isPublic = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== startDate) {
    t2 = <ModalEventViewHeader startDate={startDate} />;
    $[0] = startDate;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== clubSlug || $[3] !== isPublic || $[4] !== publicClub || $[5] !== startDate || $[6] !== type) {
    t3 = <ModalEventViewContent type={type} clubSlug={clubSlug} startDate={startDate} isPublic={isPublic} publicClub={publicClub} />;
    $[2] = clubSlug;
    $[3] = isPublic;
    $[4] = publicClub;
    $[5] = startDate;
    $[6] = type;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex flex-col gap-4">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};